/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 18,
    height: 20,
    viewBox: '0 0 18 20',
    data: '<g transform="translate(1 1)" stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linejoin="round"><path pid="0" d="M10.797 11.964l5.065 5.372-5.065-5.372z" _stroke="#008AFF" stroke-linecap="round"/><ellipse pid="1" _stroke="#234357" cx="6.471" cy="6.821" rx="6.471" ry="6.821"/></g>'
  }
})
